import {ReactNode} from "react";
import {CssBaseline} from "@mui/material";
import {ThemeProvider, ThemeOptions, createTheme} from "@mui/material/styles";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import typography from "./typography";
import componentsOverride from "./overrides";
import shadows, {customShadows} from "./shadows";
import {enUS, Localization} from "@mui/material/locale";
import GlobalStyles from "./globalStyles";
import ChartStyle from "../components/charts/ChartStyle";
import {Colors} from "../colors";
import createPalette from "../../consumer/bounce-ui/palette";

type ThemeConfigProps = {
  localization?: Localization;
  palette?: any;
  children: ReactNode;
};

function ThemeConfig({localization, palette, children}: ThemeConfigProps) {
  const resolvedPalette = palette ?? createPalette(Colors);
  const themeOptions: ThemeOptions = {
    palette: {
      ...resolvedPalette.light,
      mode: "light",
    },
    typography,
    direction: "ltr",
    shadows: shadows.light,
    customShadows: customShadows.light,
  };

  const theme = createTheme(themeOptions, localization || enUS);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ChartStyle />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export {GlobalStyles, ThemeConfig};
